const positiveId = value => {
  const id = Number(value);
  return Number.isInteger(id) && id > 0 ? id : null;
};

// Ordinary drafting and returned corrections follow case assignment (WP-02-D1).
// An unassigned legacy file retains its recorded author as the fallback owner.
// Do not use this to transfer an active review, decision, payment task or signer.
const resolveStaffWorkOwner = ({ assignedStaffProfileId, historicalStaffProfileId } = {}) =>
  positiveId(assignedStaffProfileId) || positiveId(historicalStaffProfileId);

// Assignment transfers responsibility without removing an author's existing
// role- and case-scoped permission. In particular an RM author can still act in
// submitter capacity. Routes must enforce current case/region access first.
const canPerformStaffWork = ({ actorStaffProfileId, assignedStaffProfileId, historicalStaffProfileId } = {}) => {
  const actor = positiveId(actorStaffProfileId);
  return Boolean(actor && (actor === positiveId(assignedStaffProfileId) || actor === positiveId(historicalStaffProfileId)));
};

module.exports = { resolveStaffWorkOwner, canPerformStaffWork };
